import { render } from "./CustomSelectComponent.vue?vue&type=template&id=8c475d2c&scoped=true"
import script from "./CustomSelectComponent.vue?vue&type=script&lang=js"
export * from "./CustomSelectComponent.vue?vue&type=script&lang=js"

import "./CustomSelectComponent.vue?vue&type=style&index=0&id=8c475d2c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c475d2c"]])

export default __exports__